import { render, staticRenderFns } from "./MemberComments.vue?vue&type=template&id=424aaf74&"
import script from "./MemberComments.vue?vue&type=script&lang=js&"
export * from "./MemberComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports